import { NgIf } from '@angular/common';
import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterOutlet } from '@angular/router';
import { NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { ConfigService } from '../services/config.service';
import { ProfileService } from '../services/profile.service';
import { BranchService } from './services/branch.service';

@Component({
  imports: [RouterOutlet, NgIf, NgxMaskPipe],
  providers: [
    provideNgxMask()
  ],
  selector: 'app-opportunity-shell',
  standalone: true,
  templateUrl: './opportunity-shell.component.html'
})
export class OpportunityShellComponent implements OnInit {
  whoami = '';
  brandName = '';
  branchName = '';
  callbackNumber = '';
  selectedBranch = '';
  homeUrl: string | null = null;

  public readonly configService = inject(ConfigService);
  private readonly profileService = inject(ProfileService);

  constructor(
    private readonly branchService: BranchService,
    private readonly destroyRef: DestroyRef,
  ) {
  }

  ngOnInit(): void {
    this.branchService.getValues().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(branch => {
      this.brandName = branch.brand?.name ?? '';
      this.branchName = branch.name ?? '';
      this.callbackNumber = branch.callbackNumber ?? '';
    });

    this.profileService.whoami$.subscribe(name => {
      this.whoami = name;
    });
    this.homeUrl = this.configService.homeUrl;
  }

  logout(): void {
    this.profileService.logout();
  }
}
